import { Container, Row } from "reactstrap";
import SimpleAccordion from "./SimpleAccordion";
import { Breadcrumbs } from "../../../AbstractElements";
import { Accordion, UIKits } from "../../../Constants/Constants";
import FlushAccordion from "./FlushAccordion";
import MultipleCollapse from "./MultipleCollapse";
import IconAccordion from "./IconAccordion";
import OutlineAccordion from "./OutlineAccordion";
import HorizontalAccordion from "./HorizontalAccordion";
import CollapesAccordion from "./CollapesAccordion";

const AccordionContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Accordion} parent={UIKits} />
      <Container fluid>
        <Row>
          <SimpleAccordion />
          <FlushAccordion />
          <MultipleCollapse />
          <IconAccordion />
          <OutlineAccordion />
          <HorizontalAccordion />
          <CollapesAccordion />
        </Row>
      </Container>
    </>
  );
};
export default AccordionContainer;
